const RESTRICTED_START_HOUR = 20;
const RESTRICTED_START_MINUTE = 0;
const RESTRICTED_END_HOUR = 7;
const RESTRICTED_END_MINUTE = 40;

export const checkRestrictedTimeRange = (): boolean => {
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();
  const currentTimeInMinutes = currentHour * 60 + currentMinute;

  const restrictedStartInMinutes = RESTRICTED_START_HOUR * 60 + RESTRICTED_START_MINUTE;
  const restrictedEndInMinutes = RESTRICTED_END_HOUR * 60 + RESTRICTED_END_MINUTE;

  const isAfterRestrictedStart = currentTimeInMinutes >= restrictedStartInMinutes;
  const isBeforeRestrictedEnd = currentTimeInMinutes < restrictedEndInMinutes;

  return isAfterRestrictedStart || isBeforeRestrictedEnd;
};
